//import MAAApp from './components/base.js';

// Libs
import userHandler from './lib/user.js';
import contentHandler from './lib/content.js';

// Parts
import analyticsHandler from './parts/analytics.js';
import eventListners from './parts/eventListners.js';
import scopeTest from './parts/scopeTest.js';

// Core Components
let QUEUE_COMPONENT_LIST = {};
import COMPONENT_MAASPINNER from './components/spinner.js';
QUEUE_COMPONENT_LIST.COMPONENT_MAASPINNER = COMPONENT_MAASPINNER;
import COMPONENT_MAANAV from './components/nav.js';
QUEUE_COMPONENT_LIST.COMPONENT_MAANAV = COMPONENT_MAANAV;
import COMPONENT_DSBWORKSPACE from './components/dsb-workspace.js';
QUEUE_COMPONENT_LIST.COMPONENT_DSBWORKSPACE = COMPONENT_DSBWORKSPACE;

// Application Components
import COMPONENT_DSBLIST from './components/dsb-list/dsb-list.js';
QUEUE_COMPONENT_LIST.COMPONENT_DSBLIST = COMPONENT_DSBLIST;
import COMPONENT_DSBSTEPBAR from './components/dsb-stepbar.js';
QUEUE_COMPONENT_LIST.COMPONENT_DSBSTEPBAR = COMPONENT_DSBSTEPBAR;
import COMPONENT_DSBCATCHUP from './components/dsb-catchup.js';
QUEUE_COMPONENT_LIST.COMPONENT_DSBCATCHUP = COMPONENT_DSBCATCHUP;
import COMPONENT_DSBREADER from './components/dsb-reader.js';
QUEUE_COMPONENT_LIST.COMPONENT_DSBREADER = COMPONENT_DSBREADER;
import COMPONENT_DSBPOST from './components/dsb-post.js';
QUEUE_COMPONENT_LIST.COMPONENT_DSBPOST = COMPONENT_DSBPOST;
import COMPONENT_DSBTASKS from './components/dsb-tasks.js';
QUEUE_COMPONENT_LIST.COMPONENT_DSBTASKS = COMPONENT_DSBTASKS;
import COMPONENT_DSBQUIZ from './components/dsb-quiz.js';
QUEUE_COMPONENT_LIST.COMPONENT_DSBQUIZ = COMPONENT_DSBQUIZ;
import COMPONENT_DSBAUDIO from './components/dsb-audio.js';
QUEUE_COMPONENT_LIST.COMPONENT_DSBAUDIO = COMPONENT_DSBAUDIO;
import COMPONENT_DSBVIDEO from './components/dsb-video.js';
QUEUE_COMPONENT_LIST.COMPONENT_DSBVIDEO = COMPONENT_DSBVIDEO;
//import COMPONENT_DSBFLEXSEARCH from './components/dsb-flexsearch.js';
//QUEUE_COMPONENT_LIST.COMPONENT_DSBFLEXSEARCH = COMPONENT_DSBFLEXSEARCH;



async function dynamic_import_component(name, file=false) {
  if(!file)
  {
    file = name;
  }
  let component = await import('./compile/'+file+'.js');
  component.default(); // Module loaded (export default)!
  customElements.define(name, component);
}

// contenthierachy_parts

export class DSBAPP extends HTMLElement {

  static get observedAttributes() {
    return ['layout','app_state'];
  }

  constructor() {
    super();
    console.log('constructor DSBAPP');
    var _this = this;
    this.DEBUG = true;
    this._errorMessage='';
    this.messages={};
    this._hooks={};
    this._store={};
    this._tabs = false;
    this._lock_document_title = false;
    this._app_title = document.title;
    this._app_tab_title = '';
    this._shown_update_available=false;
    this._load_complete=false;
    this._connected = false;
    this._rendered_layout = '';
    this.registeredEvents = [];
    this.globalObjects = {};
    this._onboarding_component=false;
    this._onboarding_component_shown=false;
    this._changelog_component=false;
    this._changelog_component_shown=false;
    this._inject_component=false;
    this._inject_component_shown=false;

    /**
    window.addEventListener('load', function(){
        console.log("Initial init...");
        _this.init();
      });
    */
    if(this.title)
    {
      this.title = document.title;
    }
    this.logged_in = false;
    this._root_path='';
    this._html__closebutton='';

  }

  async getGlobalObject(type,id)
  {
    if(typeof this.globalObjects == 'object' && type in this.globalObjects
      && typeof this.globalObjects[type] == 'object' && id in this.globalObjects[type])
    {
      return this.globalObjects[type][id].object;
    }
    return false;
  }

  async setGlobalObject(type, id, object,destructor_function=false)
  {
    if(!(typeof this.globalObjects == 'object'))
    {
      this.globalObjects={};
    }
    if(!(type in this.globalObjects))
    {
      this.globalObjects[type]={};
    }
    if(id in this.globalObjects[type])
    {
      if('destructor_function' in this.globalObjects[type][id] && typeof this.globalObjects[type][id].destructor_function === 'function')
      {
        await this.globalObjects[type][id].destructor_function(this.globalObjects[type][id]);
      }
    }

    this.globalObjects[type][id]={'id':id,'object':object};
    if(typeof destructor_function === 'function')
    {
       this.globalObjects[type][id].destructor_function=destructor_function;
    }
  }

  async removeGlobalObject(type, id)
  {

    let thisObject = this.getGlobalObject(type, id);
    if(thisObject)
    {
      if(typeof thisObject == 'object' && 'destructor_function' in thisObject && typeof thisObject.destructor_function === 'function')
      {
        await thisObject.destructor_function(thisObject);
      }
      this.globalObjects[type][id]={};
      delete this.globalObjects[type][id];
      return true;
    }
    return false;
  }

  disconnectedCallback()
  {
    this._log('debug','disconnectedCallback','Init');
    for(let i=0;i<this.registeredEvents.length;i++)
    {
      try
      {
        if('type' in this.registeredEvents[i] && 'object' in this.registeredEvents[i])
        {
          switch(this.registeredEvents[i].type)
          {
            case "Interval":
              window.clearInterval(this.registeredEvents[i].object);
              break;
            case "IntersectionObserver":
              if('disconnect' in this.registeredEvents[i].object)
              {
                this.registeredEvents[i].object.disconnect();
              }
              else
              {
                this._log('warning','disconnectedCallback','Cannot disconnect',this.registeredEvents[i]);
              }
              break;
            default:
              this._log('error','disconnectedCallback','Unknown object type '+this.registeredEvents[i].type,this.registeredEvents[i]);
              break;
          }
        }
      }
      catch(ex)
      {
        this._log('error','disconnectedCallback','Fatal error',ex,this.registeredEvents[i]);
      }

    }

    this.registeredEvents=[];

    for(let type in this.globalObjects)
    {
      for(let id in this.globalObjects[type])
      {
        try
        {
          this.removeGlobalObject(type,id);
        }
        catch(ex)
        {
          this._log('error','disconnectedCallback','Fatal error removing globalObjects',ex);
        }
      }
    }
    this._log('debug','disconnectedCallback','End');
  }

  get logo() {
      return this.getAttribute('logo');
  }

  set logo(newValue){
      this.setAttribute('logo', newValue);
  }

  get app_path() {
      return this.getAttribute('app_path');
  }

  set app_path(newValue){
      this.setAttribute('app_path', newValue);
  }

  get app_state() {
      return this.getAttribute('app_state');
  }

  set app_state(newValue){
      this.setAttribute('app_state', newValue);
  }

  get app_name() {
      return this.getAttribute('app_name');
  }

  set app_name(newValue){
      this.setAttribute('app_name', newValue);
  }

  get router() {
      return this.getAttribute('router');
  }

  set router(newValue){
      this.setAttribute('router', newValue);
  }

  get layout() {
      return this.getAttribute('layout');
  }

  set layout(newValue){
      this.setAttribute('layout', newValue);
  }

  get title() {
      return this.getAttribute('title');
  }

  set title(newValue){
      this.setAttribute('title', newValue);
      //this.title = newValue;
  }

  get settings() {
      return this.getAttribute('settings');
  }

  set settings(newValue){
      this.setAttribute('settings', newValue);
  }

  get_settings_override(name,default_return=false)
  {
    if(typeof this.setting == 'object' && ('overide_settings|'+name in this.setting))
    {
      try
      {
        return JSON.parse(``+this.setting['overide_settings|'+name]+``);
      }
      catch(ex)
      {
        return this.setting['overide_settings|'+name]
      }
    }
    return default_return;
  }

  get menu() {
      return this.getAttribute('menu');
  }

  set menu(newValue){
      this.setAttribute('menu', newValue);
  }

  get documents() {
      return this.getAttribute('documents');
  }

  set documents(newValue){
      this.setAttribute('documents', newValue);
  }

  get tabs() {
      if(!this._tabs)
      {
          this._tabs = JSON.parse(``+this.getAttribute('tabs')+``);

      }
      return this._tabs;
  }

  set tabs(newValue){
      this.setAttribute('tabs', newValue);
  }

  _createUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  set_store(key,value)
  {
    this._store[key]=value;
  }

  has_store(key)
  {
    if(key in this._store)
    {
      return true;
    }
    else
    {
      false;
    }
  }

  get_store(key,default_return='')
  {
    if(key in this._store)
    {
      return this._store[key];
    }
    else
    {
      return default_return;
    }
  }

  add_hook(key,name,_function,_object)
  {
    if(typeof _function == 'function')
    {
      if(!(name in this._hooks))
      {
        this._hooks[name]={};
      }
      if(!(key in this._hooks[name]))
      {
        this._hooks[name][key]=[];
      }

      this._hooks[name][key].push({'function':_function,'object':_object});
      this._log('debug','add_hook','Adding this._hooks['+name+']['+key+']',this._hooks);
    }
  }

  remove_hook(key,name='')
  {
    if(name in this._hooks)
    {
      if(key in this._hooks[name])
      {
        this._log('debug','remove_hook','Deleting this._hooks['+name+']['+key+']',this._hooks);
        delete this._hooks[name][key];
      }
    }
    else
    {
      for(let ahook in this._hooks)
      {
        if(key in this._hooks[ahook])
        {
          this._log('debug','remove_hook','Deleting this._hooks['+ahook+']['+key+']',this._hooks);
          delete this._hooks[ahook][key];
        }
      }
    }
  }

  do_hook(name)
  {
    try
    {
      if(name in this._hooks)
      {
        for(let keys in this._hooks[name])
        {
          for(let i = 0; i < this._hooks[name][keys].length; i++)
          {
            if(typeof this._hooks[name][keys][i] == 'object')
            {
              if('function' in this._hooks[name][keys][i] && typeof this._hooks[name][keys][i]['function'] == 'function')
              {
                try
                {
                  this._log('debug','do_hook','Doing this._hooks['+name+']['+keys+']['+i+']',this._hooks[name][keys][i]);
                  if('object' in this._hooks[name][keys][i])
                  {
                    this._hooks[name][keys][i]['function'](this._hooks[name][keys][i]['object']);
                  }
                  else
                  {
                    this._hooks[name][keys][i]['function']();
                  }
                }
                catch(ex)
                {
                  this._log('error','do_hook','Error trying to run hook',{'error':ex,'hook':this._hooks[name][keys][i]});
                }
              }
              else
              {
                this._log('error','do_hook','this._hooks['+name+']['+keys+']['+i+'][function] is not a function',this._hooks[name][keys][i]);
              }
            }
            else
            {
              this._log('error','do_hook','this._hooks['+name+']['+keys+']['+i+'] is not an object',this._hooks[name][keys][i]);
            }
          }
        }
      }
    }
    catch(ex)
    {
      this._log('error','do_hook','Problem executing this._hooks['+name+']',{'_hooks':this._hooks,'error':ex});
    }
  }

  _update_DocumentTitle(newValue='')
  {
    if(!this._lock_document_title)
    {
      let newtitle = ''
      if(this._app_title)
      {
        newtitle=this._app_title;
      }
      if(this._app_tab_title)
      {
        newtitle+=" - "+this._app_tab_title+"";
      }
      if(newValue && newValue.length >0)
      {
        newtitle+=" / "+newValue;
      }
      //console.error('########## SETTING TITLE:'+newtitle,this._app_title,this._app_tab_title);
      document.title = newtitle;
    }
  }

  _dynamic_define_component(name)
  {
    let this_component = 'COMPONENT_'+name.toUpperCase().replace('-','');
    if(this_component in QUEUE_COMPONENT_LIST)
    {
      customElements.define(name, QUEUE_COMPONENT_LIST[this_component]);
      delete QUEUE_COMPONENT_LIST[this_component];
    }
  }

  _toggleBackgroundColor(color=false)
  {
    if(color)
    {
      document.body.style.backgroundColor=color;
    }
    else
    {
      document.body.style.backgroundColor=getComputedStyle(this).getPropertyValue('--fwwb-header-colour-bg');
    }
  }


  async init()
  {
    try
    {

      var _this = this;

      // Register Components
      this._log('debug','init','Registering webcomponents...');
      this._dynamic_define_component('maa-spinner');
      this._dynamic_define_component('maa-nav');
      this._dynamic_define_component('maa-dsb');
      this._dynamic_define_component('dsb-workspace');

      //customElements.define('dsb-list', COMPONENT_DSBLIST);

      //customElements.define('dsb-catchup', COMPONENT_DSBCATCHUP);

      let settings = JSON.parse(``+this.settings+``);
      this.setting = settings;
      this._log('debug','init','Setting settings',this.setting);

      let menus = JSON.parse(``+this.menu+``);
      this.menus = menus;
      this._log('debug','init','Setting menu',this.menus);

      let documents = JSON.parse(``+this.documents+``);
      this.document = documents;
      this._log('debug','init','Setting document',this.documents);

      let loading_component = document.createElement("div");
      loading_component.style="text-align: center;position:absolute;top:25%; width:100%;padding:0px;margin:0px;";
      let loading_message = document.createElement("small");
      loading_message.style="font-weight:normal;font-size:10px;padding-top:10px;color:grey;";
      loading_message.innerHTML = "Setting up...";

      // Convert relative assets to allow for offline
      let font_material_icons = new FontFace("Material-Icons", 'url("'+this.app_path+'/fonts/MaterialIcons-Regular.ttf?vdmut7") format("truetype")');
      font_material_icons.load().then(function(loadedFont)
      {
          document.fonts.add(loadedFont);
          _this._log('debug','init','font_material_icons.load');
      }).catch(function(error) {
         _this._log('error','init','font_material_icons.load',error);
      });

      let font_proagrica_icons = new FontFace("Proagrica-Icons", 'url("'+this.app_path+'/fonts/Proagrica-Icons.ttf?vdmut7") format("truetype")');
      font_proagrica_icons.load().then(function(loadedFont)
      {
          document.fonts.add(loadedFont);
          _this._log('debug','init','font_proagrica_icons.load');
      }).catch(function(error) {
          _this._log('error','init','font_proagrica_icons.load',error);
      });

      let font_proagrica_outlined_icons = new FontFace("Proagrica-Icons-Outlined", 'url("'+this.app_path+'/fonts/Proagrica-Icons-Outlined.ttf?oi375n") format("truetype")');
      font_proagrica_outlined_icons.load().then(function(loadedFont)
      {
          document.fonts.add(loadedFont);
          _this._log('debug','init','font_proagrica_outlined_icons.load');
      }).catch(function(error) {
          _this._log('error','init','font_proagrica_outlined_icons.load',error);
      });

      this.style.setProperty('--fwwb-assets-404',getComputedStyle(this).getPropertyValue('--fwwb-assets-404').replace('../',this.app_path+`/`));
      this.style.setProperty('--fwwb-assets-90',getComputedStyle(this).getPropertyValue('--fwwb-assets-90').replace('../',this.app_path+`/`));
      this.style.setProperty('--fwwb-assets-503',getComputedStyle(this).getPropertyValue('--fwwb-assets-503').replace('../',this.app_path+`/`));
      this.style.setProperty('--fwwb-assets-500',getComputedStyle(this).getPropertyValue('--fwwb-assets-500').replace('../',this.app_path+`/`));

      if(('loading_logo' in settings) && settings.loading_logo !== 'off')
      {
        loading_component.innerHTML = `
          <p style="background-image:url('`+this.app_path+`/images/FW-default.svg');background-position: 50% 0px;background-size: auto;background-repeat: no-repeat;width:100%;height:78px;padding:0px;margin:0px;"></p>
          <p style=" position:relative;height:84px;width:100%;padding:0px;margin:0px;">
            <maa-spinner></maa-spinner>
          </p>
          <h3 style="font-weight:normal;font-size:12px;padding-top:10px;margin:0px;">Loading....</h3>
        `;
      }
      else
      {
         loading_component.innerHTML = `
          <maa-spinner></maa-spinner>
        `;
      }
      this.innerHTML = '';
      loading_component.append(loading_message);
      this.append(loading_component);

       // Add parts
      this._setAnalytics = analyticsHandler;
      this._setApplicationListners = eventListners;

      this.dsbClient = {};

      // Setup Event listners
      this._log('debug','init','Setup event listners...');
      this._setApplicationListners();

      // Setup CRON
      if(('check_for_update' in settings) && settings.check_for_update !== 'off')
      {
        this.registeredEvents.push({'type':'Interval','object':setInterval(function(){
          window.dispatchEvent(new CustomEvent('fw-workspace-check_for_update'));
        },(!isNaN(settings.check_for_update)?settings.check_for_update:60000))});
      }


      // Get additional customElements
      /**
      if(`customElements` in settings)
      {
        if(settings.customElements !== null && typeof Array.isArray(settings.customElements))
        {
          for(let i = 0; i < settings.customElements.length; i++)
          {
            // ok now what :)
          }
        }
      }
      */

      if(!('default_service' in settings))
      {
        settings.default_service='post';
      }

      if(!(`fw_tnc_url` in settings))
      {
        settings.fw_tnc_url = 'https://www.markallengroup.com/terms-and-conditions/';
      }

      loading_message.innerHTML='Initialising userHandler...';
      this.dsbClient.user = new userHandler();
      if(this.dsbClient.user)
      {
        let user_settings = {};
        if('app_path' in settings)
        {
          user_settings.app_path=settings.app_path;
        }
        if('app_hash_url' in settings)
        {
          user_settings.app_hash_url=settings.app_hash_url;
        }
        for(let setting_key in settings)
        {
          if(setting_key.startsWith('user__'))
          {
            user_settings[setting_key.replace('user__','')]=settings[setting_key];
          }
        }
        await this.dsbClient.user.init(user_settings);
      }

      loading_message.innerHTML='Initialising contentHandler...';
      this.dsbClient.content = new contentHandler();

      if(`dsb_client_url` in settings)
      {
        let hooks = {};
        hooks.filters = {};
        hooks.filters.formatData_lookup = function(type, value)
        {
          if("lookups" in settings)
          {
            if(typeof settings.lookups === 'object' && settings.lookups !== null)
            {
              if(type in settings.lookups)
              {
                if( value in settings.lookups[type])
                {
                  return settings.lookups[type][value];
                }
              }
              else
              {
                console.log('formatData_lookup::Not sure what '+type+' is...');
              }
            }
            else
            {
              console.log('formatData_lookup:: Missing lookups...');
            }
          }
          return value;
        }

        hooks.async_filters = {};
        hooks.async_filters.formatData_lookup = async function(type, value,force=false)
        {
          if('app_lookups_url' in settings)
          {

            let lookup=false;
            // Cache query exp after 1 min
            if(!force && 'formatData_lookup' in _this.dsbClient.content.cache.filters && typeof _this.dsbClient.content.cache.filters['formatData_lookup'] === 'object' && _this.dsbClient.content.cache.filters['formatData_lookup']!=null)
            {
              if('timestamp' in _this.dsbClient.content.cache.filters['formatData_lookup'])
              {
                let last_one_min = ((Math.floor(+new Date() / 1000))-(60));
                if(_this.dsbClient.content.cache.filters['formatData_lookup'].timestamp > last_one_min)
                {
                  if('data' in _this.dsbClient.content.cache.filters['formatData_lookup'])
                  {
                    //console.debug('dsbClient.content.async_filters.formatData_lookup::Using cache');
                    lookup=_this.dsbClient.content.cache.filters['formatData_lookup'].data;
                  }
                }
              }
            }

            let has_updated=false;
            if(!lookup || force)
            {
              lookup = await _this.dsbClient.content.get(settings.app_lookups_url,'');
              has_updated=true;
              if(lookup.state=='success' && 'data' in lookup)
              {
                lookup=lookup.data;
                console.debug('dsbClient.content.async_filters.formatData_lookup::Updated');
                _this.dsbClient.content.cache.filters['formatData_lookup']={};
                _this.dsbClient.content.cache.filters['formatData_lookup'].timestamp=Math.floor(+new Date() / 1000);
                _this.dsbClient.content.cache.filters['formatData_lookup'].data=lookup;
              }

            }

            if(typeof lookup === 'object' && lookup !== null)
            {
              if(type in lookup)
              {
                if( value in lookup[type])
                {
                  return lookup[type][value];
                }
                else
                {
                  if(!has_updated)
                  {
                    console.debug('dsbClient.content.async_filters.formatData_lookup::Loop to force update');
                    return hooks.async_filters.formatData_lookup(type, value,true);
                  }
                }
              }
              else
              {
                console.debug('dsbClient.content.async_filters.formatData_lookup::Not sure what '+type+' is...');
              }
            }
            else
            {
              console.debug('dsbClient.content.async_filters.formatData_lookup:: Missing lookups...');
            }
          }
          console.debug('dsbClient.content.async_filters.formatData_lookup No results, defaulting...');
          return hooks.filters.formatData_lookup(type, value);
        }

        await this.dsbClient.content.init(hooks,this.dsbClient.user);
        await this.dsbClient.content.initDSBClient(settings.dsb_client_url);
        if(`image_path` in settings)
        {
            this.dsbClient.content.image_path = settings.image_path;
        }

        if(this.app_path)
        {
            this.dsbClient.content.app_path = this.app_path;
        }

        this.dsbClient.content.default_service=settings.default_service;
      }

       // Setup and Instantiate Analytics
      this._setAnalytics();

      // Check for installation preconditions
      this._log('debug','init','Checking for installation preconditions...');

      if(('preconditions' in settings) && (settings.preconditions == 'on'))
      {
        loading_message.innerHTML='Checking for installation preconditions...';
        // App must be installed
        if(('preconditions__install' in settings) && settings.preconditions__install == 'on')
        {
          this._log('debug','init','Has installation preconditions');
          if(!this.dsbClient.user.env.isInstalled())
          {
            this._log('debug','init','Requires installation');
            this._log('debug','init','Fire installation pending event...');
            window.dispatchEvent(new CustomEvent('dsb-pwa-page_event', {detail:{
              'event_type':'installation_pending',
              'data': {
                'source': 'dsb-app.isInstalled'
              }
            }}));

            loading_message.innerHTML='Requires installation';
            let thisOS = this.dsbClient.user.env.getOS();
            //alert('jasons quick test'+JSON.stringify(this.dsbClient.user.env.get()));
            if('preconditions__install-'+thisOS+'_postid' in settings)
            {
              await this._dynamic_define_component('dsb-post');
              let component = document.createElement("dsb-post");
              component.setDSBClient(this.dsbClient);
              component.setAttribute(`service`, 'static');
              component.setAttribute('post_id', settings['preconditions__install-'+thisOS+'_postid']);
              component.innerHTML = `<maa-spinner></maa-spinner>`;
              window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content:component,hide:['close','refresh']}}));
              return;

            }
            else if('preconditions__install_postid' in settings)
            {
                await this._dynamic_define_component('dsb-post');
                let component = document.createElement("dsb-post");
                component.setDSBClient(this.dsbClient);
                component.setAttribute(`service`, 'static');
                component.setAttribute(`settings`,JSON.stringify({'base_update':'off','header':'off','clean_body':'on','pulldown_refresh':'off','lazy_images':'off'}));
                component.setAttribute('post_id', settings.preconditions__install_postid);
                component.innerHTML = `<maa-spinner></maa-spinner>`;
                window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content:component,hide:['close','refresh']}}));
                return;
            }
            else
            {
                let component = document.createElement("div");
                let component_uid = this._createUUID();
                component.innerHTML = `
                <div>
                <center><svg style="max-width:300px;" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" viewBox="0 0 24 24" width="40%" fill="#fcdc18"><g><rect fill="none" height="24" width="24"/></g><g><g><path d="M20,17H4V5h8V3H4C2.89,3,2,3.89,2,5v12c0,1.1,0.89,2,2,2h4v2h8v-2h4c1.1,0,2-0.9,2-2v-3h-2V17z"/><polygon points="17,14 22,9 20.59,7.59 18,10.17 18,3 16,3 16,10.17 13.41,7.59 12,9"/></g></g></svg>
                <h2>This app requires installation</h2>
                <p>In your browsers menu please click click "Add to home".<br/>
                <small>Note: You may be asked to login and/or enter a pin code on install</small>
                </p>
                </center>
                </div>
                `;
                window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content:component,hide:['close','refresh']}}));
                return;
            }
          }
        }

      }



      if(`dsb_user_url` in settings)
      {

        if(!('refresh_token' in settings))
        {
          settings.refresh_token = '';
        }

        loading_message.innerHTML='Logging in user...';
        await this.dsbClient.user.initDSBClient(settings.dsb_user_url,settings.refresh_token);

        // Application user settings
        if(typeof this.dsbClient.user.custom_settings == 'object')
        {
          if(!('user_settings' in settings))
          {
            settings['user_settings']={};
          }


          settings['user_settings']['Font-size']={
            "name": "Font size",
            "key": "content_preferences_fontsize",
            "desc": "This applies to content only",
            "settings": ""
          };

          settings['user_settings']['Font-size'].getBody=function(){

            let currentFontSize = _this.style.getPropertyValue('--fwwb-body-size-font');
            let currentStep = 3;
            let up_button = document.createElement("button");
            up_button.style='width:';
            up_button.innerHTML="+"

            let sizeSteps={};
            sizeSteps[1]={'label':'Min','property':'var(--fwwb-default-size-font-xsmall)'};
            sizeSteps[2]={'label':'Small','property':'var(--fwwb-default-size-font-small)'};
            sizeSteps[3]={'label':'Default','property':'var(--fwwb-default-size-font-base)'};
            sizeSteps[4]={'label':'Large','property':'var(--fwwb-default-size-font-large)'};
            sizeSteps[5]={'label':'Max','property':'var(--fwwb-default-size-font-xlarge)'};

            console.error(currentFontSize);

            for(let sizeSteps_no in sizeSteps)
            {
               console.error(currentFontSize,sizeSteps[sizeSteps_no].property);
              if(sizeSteps[sizeSteps_no].property==currentFontSize)
              {
                currentStep=sizeSteps_no;
              }
            }

            let state = document.createElement("div");
            state.innerHTML=sizeSteps[currentStep].label;
            state.style="text-align:center;font-style:italics;"
            state.setAttribute('data-sizeStep',currentStep);

            let _font_size = getComputedStyle(_this).getPropertyValue('--fwwb-body-size-font');
            up_button.onclick = async function(e){
              let nextStep=parseInt(state.getAttribute('data-sizeStep'));
              nextStep=nextStep+1;
              if(nextStep in sizeSteps)
              {
                _this.style.setProperty('--fwwb-body-size-font',sizeSteps[nextStep].property);
                state.setAttribute('data-sizeStep',nextStep);
                state.innerHTML=sizeSteps[nextStep].label;

                if(!await _this.dsbClient.user.custom_settings.set(settings['user_settings']['Font-size']['key'], sizeSteps[nextStep]))
                {
                  throw "Save seems to have failed";
                }
              }
            };

            let down_button = document.createElement("button");
            down_button.innerHTML="-"
            down_button.onclick = async function(e){
              let nextStep=parseInt(state.getAttribute('data-sizeStep'));
              nextStep=nextStep-1;
              console.log(nextStep,sizeSteps);
              if(nextStep in sizeSteps)
              {
                _this.style.setProperty('--fwwb-body-size-font',sizeSteps[nextStep].property);
                state.setAttribute('data-sizeStep',nextStep);
                state.innerHTML=sizeSteps[nextStep].label;
                if(!await _this.dsbClient.user.custom_settings.set(settings['user_settings']['Font-size']['key'], sizeSteps[nextStep]))
                {
                  throw "Save seems to have failed";
                }
              }
            };

            let table = document.createElement("table");
            table.style='width:100%';
            let table_tr = document.createElement("tr");
            let table_td_one = document.createElement("td");
            table_td_one.style='width:30%';
            let table_td_two = document.createElement("td");
            table_td_two.style='width:40%';
            let table_td_three = document.createElement("td");
            table_td_three.style='width:30%';
            table_td_one.append(down_button);
            table_td_two.append(state);
            table_td_three.append(up_button);
            table_tr.append(table_td_one);
            table_tr.append(table_td_two);
            table_tr.append(table_td_three);
            table.append(table_tr);
            return table;
          };

          _this.add_hook('dsb-app',"updated_setting-"+settings['user_settings']['Font-size']['key'],async function(){
            let fontsize = await _this.dsbClient.user.custom_settings.get_setting(settings['user_settings']['Font-size']['key']);
            _this._log('debug','hook__'+"updated_setting-"+settings['user_settings']['Font-size']['key'],'Has font_size=',fontsize);
            if(typeof fontsize == 'object' && fontsize != null && ('user_data' in fontsize) && (typeof fontsize.user_data == 'object') && ('label' in fontsize.user_data) && ('property' in fontsize.user_data))
            {
              _this.style.setProperty('--fwwb-body-size-font',fontsize.user_data.property);
              _this._log('info','hook__'+"updated_setting-"+settings['user_settings']['Font-size']['key'],'Has font_size=',fontsize.user_data.label);
            }
          },this);

          settings['user_settings']['Theme']={
            "name": "Theme",
            "key": "app_preferences_theme__"+this.app_name,
            "desc": "",
            "settings": "",
            "fields": [
              {
                "type": "select",
                "title": "Default",
                "value": "theme_yellow",
                "settings": ""
              },
              {
                "type": "select",
                "title": "Light",
                "value": "theme_yellow-light",
                "settings": ""
              },
              {
                "type": "select",
                "title": "Dark",
                "value": "theme_yellow-dark",
                "settings": ""
              },
            ]
          };

          _this.add_hook('dsb-app',"updated_setting-app_preferences_theme__"+_this.app_name,async function(){
            let theme = JSON.parse(JSON.stringify(await _this.dsbClient.user.custom_settings.get_setting("app_preferences_theme__"+_this.app_name)));
            _this._log('debug','hook__'+"updated_setting-app_preferences_theme__"+_this.app_name,'Running',theme);
            if(theme && typeof theme == 'object' && ('fields' in theme))
            {
              let setTheme = '';
              for(let aTheme in theme.fields)
              {
                if(setTheme == '')
                {
                  setTheme=theme.fields[aTheme].value;
                }

                if('user_data' in theme.fields[aTheme] && theme.fields[aTheme].user_data == true)
                {
                  setTheme = theme.fields[aTheme].value;
                  continue;
                }
              }
              _this._log('debug','hook__'+"updated_setting-app_preferences_theme__"+_this.app_name,'Setting to '+setTheme)
              _this.classList = setTheme;
            }
          },this);

          for(let auser_settings in settings.user_settings)
          {
            if('key' in settings.user_settings[auser_settings])
            {
                this.dsbClient.user.custom_settings.add_setting(settings.user_settings[auser_settings].key,settings.user_settings[auser_settings]);
            }
          }

          _this.do_hook("updated_setting-"+settings['user_settings']['Font-size']['key']);
          _this.do_hook("updated_setting-app_preferences_theme__"+_this.app_name);
        }
      }
      else
      {
        throw "Missing dsb_user_url setting";
      }

      // Set content
      if(`dsb_client_url` in settings)
      {
        loading_message.innerHTML='Connecting content api...';
        await this.dsbClient.content.initDSBClient(settings.dsb_client_url);
      }
      else
      {
        throw "Missing dsb_client_url setting";
      }

      // Set theme
      if('theme' in settings)
      {
        this.classList.add(settings.theme);
      }

      var hashchange = function() {
        let hash = location.hash;
        if(hash.length > 0)
        {
          if(hash.indexOf("#/") > -1)
          {
            hash = hash.substring((hash.indexOf("#/")+2),hash.length);
          }
          hash = hash.split("/");
          _this._route(hash[0], hash[1], hash[2], hash.slice(3,hash.length), '');
        }
      };

      window.addEventListener('dsb_app-reload', function(){
        console.debug("Reloading from path...");
        //Fire hashchange function for initial load
        hashchange();
      });

      window.addEventListener('hashchange', function(){
        console.debug("Hash change detected...");
        hashchange();
      }, false);

      this._log('debug','init',"Setting viewport...");
      this.dsbClient.user.env.refreshViewPort();

      if(!await this.dsbClient.user.is_loggedin())
      {
        this._log('warning','init','Not logged in...');
        this._log('debug','init','Fire installation pending_login event...');
        window.dispatchEvent(new CustomEvent('dsb-pwa-page_event', {detail:{
          'event_type':'pending_login',
          'data': {
            'source': 'dsb-app.isInstalled'
          }
        }}));
        this._errorMessage = 'Not Logged in....';
        loading_message.innerHTML='Not logged in...';
        if(!await this.dsbClient.user.is_offline())
        {
          if(this.dsbClient.user.isPending())
          {
            loading_message.innerHTML='Login pending...';
            this.setAttribute(`layout`, `login-pending`);
          }
          else
          {

              if(!this.dsbClient.user.run_login_redirect())
              {
                this.setAttribute(`layout`, `login`);
              }
              else
              {
                  //throw "Cannot login to app";
                  return;
              }
          }
        }
        else
        {
            this.setAttribute(`layout`, `offline`);
        }
        this._render();
      }
      else
      {
        this._log('debug','init','You appear to be logged in :)');

        // Ok check for new install
        this._log('debug','init','Checking if your new here...');
        _this.dsbClient.user.custom_data.has('_installation_complete',async function(result){
          _this._log('debug','init/installation_complete','Checking Install...',result);
          let data = {};
          if(result)
          {
            data = await _this.dsbClient.user.custom_data.get('_installation_complete');
          }

          if(!(typeof data === 'object'))
          {
            data={};
          }
          if(!(_this.app_name in data))
          {
            data[_this.app_name]=Date.now();
            _this._log('debug','init/installation_complete','New Install',data);
            _this.dsbClient.user.custom_data.set('_installation_complete',data);
            window.dispatchEvent(new CustomEvent('dsb-pwa-page_event', {detail:{
              'event_type':'installation_complete',
              'data': {
                'source': 'dsb-app.isInstalled'
              }
            }}));
          }
          else
          {
            console.error('@2.1',data);
            _this._log('debug','init/installation_complete','Ok returning user, already installed "'+_this.app_name+'"',data);
          }
           console.error('@end');

        },true);

        loading_message.innerHTML='Checking preconditions...';
         // Ok check for preconditions
        if(('preconditions' in settings) && (settings.preconditions == 'on'))
        {
           this._log('debug','init','Has preconditions');

          // App requires pin
          if(('preconditions__pin' in settings) && settings.preconditions__pin !== 'off')
          {
            let chars_to_numbers = function(string){
              if(isNaN(string))
              {
                let matrix = { a: 1, b: 2, c: 3, d: 4, e: 5, f: 6, g: 7, h: 8, i: 9, j: 10, k: 11, l: 12, m: 13, n: 14, o: 15, p: 16, q: 17, r: 18, s: 19, t: 20, u: 21, v: 22, w: 23, x: 24, y: 25, z: 26 }
                let result = [];
                for(let i = 0; i<string.length;i++)
                {
                  result.push(matrix[string[i]]);
                }
                return result.join('');
              }
              return string;
            };


            let expected_accesstoken = chars_to_numbers((settings.preconditions__pin=='app_name_as_number' || settings.preconditions__pin=='on'?this.app_name:settings.preconditions__pin));
            let _fw_workbench_accesstoken = this.dsbClient.user.getUserCookie('fw_workbench_'+this.app_name+'_pin');

            // Check for legacy cookie
            let delete_lagacy_cookie = false;
            if(!_fw_workbench_accesstoken)
            {
              _fw_workbench_accesstoken = this.dsbClient.user._getCookie('fw_workbench_'+this.app_name+'_pin');
              delete_lagacy_cookie=true;
            }

            if(_fw_workbench_accesstoken && _fw_workbench_accesstoken == expected_accesstoken)
            {
              // ok cool
              // Migrate to new cookie
              if(delete_lagacy_cookie)
              {
                this.dsbClient.user.setUserCookie('fw_workbench_'+this.app_name+'_pin',_fw_workbench_accesstoken,3650);
                this.dsbClient.user._deleteCookie('fw_workbench_'+this.app_name+'_pin','/',window.location.hostname);
              }
            }
            else
            {
              let component = document.createElement("div");
              let component_uid = this._createUUID();
              component.innerHTML = `
              <div>
                <center>
                <svg style="max-width:300px;" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" viewBox="0 0 24 24" width="40%" fill="#fcdc18"><g><path d="M0,0h24v24H0V0z" fill="none"/></g><g><g><path d="M20,4H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V6C22,4.9,21.1,4,20,4z M7.64,15H6.49v-4.5l-0.9,0.66 l-0.58-0.89L6.77,9h0.87V15z M13.5,15H9.61v-1.02c1.07-1.07,1.77-1.77,2.13-2.15c0.4-0.42,0.54-0.69,0.54-1.06 c0-0.4-0.31-0.72-0.81-0.72c-0.52,0-0.8,0.39-0.9,0.72l-1.01-0.42c0.01-0.02,0.18-0.76,1-1.15c0.69-0.33,1.48-0.2,1.95,0.03 c0.86,0.44,0.91,1.24,0.91,1.48c0,0.64-0.31,1.26-0.92,1.86c-0.25,0.25-0.72,0.71-1.4,1.39l0.03,0.05h2.37V15z M18.75,14.15 C18.67,14.28,18.19,15,16.99,15c-0.04,0-1.6,0.08-2.05-1.51l1.03-0.41c0.03,0.1,0.19,0.86,1.02,0.86c0.41,0,0.89-0.28,0.89-0.77 c0-0.55-0.48-0.79-1.04-0.79h-0.5v-1h0.46c0.33,0,0.88-0.14,0.88-0.72c0-0.39-0.31-0.65-0.75-0.65c-0.5,0-0.74,0.32-0.85,0.64 l-0.99-0.41C15.2,9.9,15.68,9,16.94,9c1.09,0,1.54,0.64,1.62,0.75c0.33,0.5,0.28,1.16,0.02,1.57c-0.15,0.22-0.32,0.38-0.52,0.48 v0.07c0.28,0.11,0.51,0.28,0.68,0.52C19.11,12.91,19.07,13.66,18.75,14.15z"/></g></g></svg>
                <h3>This app is currently in closed beta.</h3>
                <p style="align:center;font-size:15px;">To access please enter your closed beta access pin in the box below, doing so means you agree to the <a href="`+settings.fw_tnc_url+`" target="_blank">terms and conditions</a>.</p>
                </center>
                <p>
                `+(_fw_workbench_accesstoken.length>0?'<div style="border:solid 1px #d2222a;background-color:#fbebed;margin: auto;width: 50%;margin-bottom: 10px;padding-left: 10px;display: block;padding-top: 10px;padding-bottom: 10px;padding-right: 10px;">Sorry this token is either invalid or has expired</div>':'')+`
                <input id="`+component_uid+`__access_restriction_token" type="number" alt="Access code" value="" style="height: 44px;width: 50%;margin: auto;display: block;text-align: center;margin-bottom: 10px;">
                </div>
              `;
              let component_submit = document.createElement("span");
              component_submit.style = 'display:inline-block;background-color: #d92835;color:#fff;font-size: 14px; padding-left: 10px;  padding-right: 10px; cursor: pointer; height: 44px; line-height: 44px; width: 50%; margin: auto; display: block; text-align: center;';
              component_submit.innerHTML = 'Participate in beta';
              component_submit.onclick = function ()
              {
                  let token = document.getElementById(component_uid+'__access_restriction_token');
                  _this.dsbClient.user.setUserCookie('fw_workbench_'+_this.app_name+'_pin',token.value,3650);
                  window.location.reload();
              }
              component.append(component_submit);
              window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content:component,hide:['close','refresh']}}));
              return;
            }

          }

          // Onboarding
          if('onboarding_postid|version' in settings)
          {
            let _fw_workbench_onboarding = this.dsbClient.user.getUserCookie('fw_workbench_'+this.app_name+'_onboarding');
            if(_fw_workbench_onboarding && _fw_workbench_onboarding==settings['onboarding_postid|version'])
            {
              //Skip onboarding
            }
            else
            {
              let post_id = settings['onboarding_postid|version'];
              post_id = post_id.split('|')[0];
              await this._dynamic_define_component('dsb-post');
              this._onboarding_component = document.createElement("dsb-post");
              this._onboarding_component.setDSBClient(this.dsbClient);
              this._onboarding_component.setAttribute(`service`, 'static');
              this._onboarding_component.setAttribute('post_id', post_id);
              this._onboarding_component.setAttribute(`settings`,JSON.stringify({'base_update':'off','header':'off','clean_body':'on','pulldown_refresh':'off','lazy_images':'off'}));
              this._onboarding_component.innerHTML = `<maa-spinner></maa-spinner>`;
              this.dsbClient.user.setUserCookie('fw_workbench_'+_this.app_name+'_onboarding',settings['onboarding_postid|version'],3650);// 10 Year cookie
            }

          }
        }

        // Inject any needed scripts
        if('inject__hiddenpostid' in settings)
        {
          let _inject_component_post_id = settings['inject__hiddenpostid'];
          if(!isNaN(_inject_component_post_id) && _inject_component_post_id>0)
          {
            await this._dynamic_define_component('dsb-post');
            this._inject_component = document.createElement("dsb-post");
            this._inject_component.style='display:none;position:absolute;left:calc(var(--fwwb-fullwidth)*2);top:0px;height:0px;';
            this._inject_component.id='fw_workbench_inject__hiddenpostid';
            this._inject_component.setDSBClient(this.dsbClient);
            this._inject_component.setAttribute(`service`, 'static');
            this._inject_component.setAttribute('post_id', _inject_component_post_id);
            this._inject_component.setAttribute(`settings`,JSON.stringify({'base_update':'off','header':'off','clean_body':'on','pulldown_refresh':'off','lazy_images':'off','toolbar':'off','page_view_onload':'off'}));
            this._inject_component.innerHTML = `<maa-spinner></maa-spinner>`;
          }
        }

         // Change log
        if('changelog_postid|version' in settings)
        {
          let _fw_workbench_changelog = this.dsbClient.user.getUserCookie('fw_workbench_'+this.app_name+'_changelog');
          if(_fw_workbench_changelog && _fw_workbench_changelog==settings['changelog_postid|version'])
          {
            //Skip onboarding
          }
          else
          {
            let post_id = settings['changelog_postid|version'];
            post_id = post_id.split('|')[0];
            await this._dynamic_define_component('dsb-post');
            this._changelog_component = document.createElement("dsb-post");
            this._changelog_component.setDSBClient(this.dsbClient);
            this._changelog_component.setAttribute(`service`, 'static');
            this._changelog_component.setAttribute('post_id', post_id);
            this._changelog_component.setAttribute(`settings`,JSON.stringify({'base_update':'off','header':'off','clean_body':'on','pulldown_refresh':'off','lazy_images':'off'}));
            this._changelog_component.innerHTML = `<maa-spinner></maa-spinner>`;
            this.dsbClient.user.setUserCookie('fw_workbench_'+_this.app_name+'_changelog',settings['changelog_postid|version'],3650);// 10 Year cookie
          }
        }

        if(location.hash.length > 0)
        {
          //Fire hashchange function for initial load
          loading_message.innerHTML='Resuming...';
          hashchange();
        }
        else
        {
          // Go find tab or app
          loading_message.innerHTML='Rendering...';
          this._render();
        }
      }
    }
    catch(ex)
    {
        this._log('error','init', 'Cannot init DSBAPP!', ex);
        this._errorMessage=ex;
        this.layout='error';
        this._render();
    }

  }

   _log(type,source,message,data='')
  {
    let _message = 'dsb-app/DSBAPP::'+source+'- '+message;
    switch(type)
    {
       case "debug":
         console.debug(_message,data);
        break;
      case "warning":
         console.warn(_message,data);
        break;
      case "error":
         console.error(_message,data);
        break;
      default:
          console.log(_message,data);
    }
  }

  attributeChangedCallback(name, oldValue, newValue)
  {
    if(`app_state` == name && oldValue != null && oldValue!==newValue )
    {
      this.connectedCallback();
    }
  }

  connectedCallback()
  {
    document.body.style.backgroundColor = "#4a4a4a";
    if(this.app_state =='wait')
    {
      let _this = this;
      // Ok waiting.....
      this._log('debug','connectedCallback','Waiting....',this.app_state);
      this.timeout__wait = setTimeout(function(){
          console.error('###### --- fw-workbench CRON/connectedCallback -----');
          if(_this.app_state == 'wait')
          {
            _this.innerHTML=`
            <div style="text-align: center;position:absolute;top:25%; width:100%;padding:0px;margin:0px">
            <p style="background-image:url('`+_this.app_path+`/images/FW-default.svg');background-position: 50% 0px;background-size: auto;background-repeat: no-repeat;width:100%;height:78px;padding:0px;margin:0px;"></p>
            <h3 style="font-weight:normal;font-size:12px;padding-top:10px;margin:0px;">Updated, please restart the app</h3>
            <small style="font-weight:normal;font-size:10px;padding-top:10px;color:grey;">Sorry, this update requires a restart.</small>
            </div>'`;
          }
        },30000);
    }
    else
    {
      this._log('debug','connectedCallback','Runnig init....',this.app_state);
      if(this.timeout__wait)
      {
        clearTimeout(this.timeout__wait);
      }

      //Setup cron


      this._connected = true;
      this.init();
    }
  }

  async _render(mode=null)
  {
    let _this = this;
    try
    {
      this._root_path = '/#/'+this.layout;

      let route = `document.querySelector('dsb-app').route(this);`;
      let tabbed_element = '';

      if(this.tabs && this.setting)
      {
          if(Object.keys(this.tabs).length > 1)
          {
            tabbed_element = document.createElement("nav");
            let tabbed_element_ul = document.createElement("ul");

            if((typeof this.setting === 'object') && (this.setting !== null) && ('tabs__position' in this.setting))
            {
              if(this.setting.tabs__position == 'header')
              {
                this.setAttribute('tabs-position',this.setting.tabs__position);
              }
            }
            for(let aTab in this.tabs)
            {
                if('id' in this.tabs[aTab])
                {
                    let _li = document.createElement("li");
                    let li_class = 'show-name';
                    if('icon' in this.tabs[aTab])
                    {
                      if((typeof this.setting === 'object') && (this.setting !== null) && ('tabs__showicon' in this.setting))
                      {
                        if(this.setting.tabs__showicon == 'on')
                        {
                          li_class = this.tabs[aTab].icon;
                        }
                        else
                        {
                          tabbed_element.classList.add('no-icons');
                        }
                      }
                      else
                      {
                        li_class = this.tabs[aTab].icon;
                      }
                    }
                    if((typeof this.setting === 'object') && (this.setting !== null) && ('tabs__showtitle' in this.setting) && this.setting.tabs__showtitle == 'on')
                    {
                      // cool
                    }
                    else
                    {
                      li_class+=' hide';
                    }
                    if((typeof this.setting === 'object') && (this.setting !== null) && ('tabs__style' in this.setting))
                    {
                      tabbed_element_ul.classList.add(this.setting['tabs__style']);
                    }
                    _li.innerHTML = `<a id="/`+this.layout+`/static/post/`+this.tabs[aTab].id+`" href="javascript:return false;" onclick="window.location.hash='/`+this.layout+`/static/post/`+this.tabs[aTab].id+`'"class="`+li_class+` `+(window.location.hash == `#/`+this.layout+`/static/post/`+this.tabs[aTab].id?' active':'')+`"><span>`+this.tabs[aTab].name+`<span></a>`;
                      tabbed_element_ul.append(_li);
                }
                else
                {
                    console.error('Missing id in Tab', this.tabs[aTab]);
                    throw 'Issue with Tab';
                }
            }
            tabbed_element.append(tabbed_element_ul);

          }
      }

      // Check for tabs in setup if no layout has been specified
      if(!this.layout && !location.hash)
      {
          this.default_layout=false;
          if(typeof this.setting === 'object' && 'default_layout' in this.setting)
          {
            this.default_layout=this.setting.default_layout;
          }
          if(this.tabs && this.setting)
          {
              if(Object.keys(this.tabs).length > 1)
              {

                  this.layout = `tabbed`;
              }
              else
              {
                  this.layout = `single`;
              }
              if(this.default_layout)
              {
                this.layout = this.default_layout;
              }

              for(let aTab in this.tabs)
              {
                  if('id' in this.tabs[aTab])
                  {
                      window.location.hash = '/'+this.layout+'/static/post/'+this.tabs[aTab].id;
                      return;
                  }
                  else
                  {
                      console.error('Missing id in Tab', this.tabs[aTab]);
                      throw 'Issue with Tab';
                  }
              }
          }
          else
          {
            if(this.default_layout)
            {
              this.layout = this.default_layout;
            }
          }
      }

      console.log('Setting layout '+this.layout+'...',this.setting)

      //<div class="icon-chevron-left" onclick="window.parent.postMessage('dsb_app-iframeclose');"><span style="padding-right:10px;cursor:pointer;">Back</span></div>

      this._html_offlineindicator = `<div class="m-icon-offline fw_workspace__offline_indicator" style="display:none;margin-left: 0px;font-size: 25px;"><span style="padding-right:10px;">&nbsp;<span></span></span></div>`;

      this._html_refresh = `<div class="icon-refresh icon-clickable" id="fw_workspace__update_indicator" onclick="window.location.reload(true);this.className='icon-refresh icon-rotate icon-clickable'" style="font-size:25px;"><span style="padding-right:10px;">&nbsp;</span></div>`;

      this._html__closebutton = `<div class="icon-chevron-left" onclick="window.parent.postMessage('dsb_app-iframeclose');"><span style="padding-right:10px;cursor:pointer;">Back<span></div>`;
      if((typeof this.setting === 'object') && (this.setting !== null) && ('close_button' in this.setting))
      {
        switch(this.setting['close_button'])
        {
          case "iframe_back":
              this._html__closebutton = `<div class="icon-chevron-left" onclick="window.parent.postMessage('dsb_app-iframeclose');"><span style="padding-right:10px;cursor:pointer;">Back<span></div>`;
              break;
          case "iframe_close":
              this._html__closebutton = `<div class="m-icon-close icon-clickable" onclick="window.parent.postMessage('dsb_app-iframeclose');" style="margin-left: 0px;font-size: 25px;"><span style="padding-right:10px;">&nbsp;<span></span></span></div>`;
              break;
          default:
              this._html__closebutton="";
              break;
        }

      }

      //<div id="dsb-pwa_menu" class="icon-menu icon-clickable" style="margin-left: 0px;font-size: 25px;"><span style="">&nbsp;<span></span></span></div>


      this._html_header = `
      <header>
        <ul>
          <li class="menu" id="dsb-pwa_menu">
          </li>
          <li class="title"><div><span id="dsb-pwa_appname"></span><span id="dsb-pwa_title"></span></div></li>
          <li class="tray" id="dsb-pwa_tray">
            `+this._html_refresh+this._html_offlineindicator+this._html__closebutton+`
          </li>
        </ul>
      </header>`;



      this._toggleBackgroundColor();

      this._load_complete=true;
      switch(this.layout)
      {
        case "body-only":
          this.classList.add('focus');
          this.classList.add('tabs-off');
          this.innerHTML = `
            <dsb-modal>
              <header>
                <ul>
                  <li class="title"></li>
                  <li class="logo"></li>
                  <li class="tray"><div class="icon-close" onclick="document.querySelector('dsb-modal').classList.toggle('show');"><span>Close<span></div></li>
                </ul>
              </header>
              <dsb-modal-workspace></dsb-modal-workspace>
            </dsb-modal>
            <header></header>
            <dsb-workspace>
              <maa-spinner></maa-spinner>
            </dsb-workspace>
          `;
          break;
        case "reader":
        case "single":
          this.innerHTML = `
            <dsb-modal>
              <header>
                <ul>
                  <li class="title"></li>
                  <li class="logo"></li>
                  <li class="tray"><div class="icon-close" onclick="document.querySelector('dsb-modal').classList.toggle('show');"><span>Close<span></div></li>
                </ul>
              </header>
              <dsb-modal-workspace></dsb-modal-workspace>
            </dsb-modal>
             `+this._html_header+`
            <dsb-workspace>
              <maa-spinner></maa-spinner>
            </dsb-workspace>
          `;
          break;
        case "comrisk":
          this.innerHTML = `
            <header>
              <ul>
                <li class="logo"><a href="" onclick="return false;"><img src="`+this.logo+`" alt="Farmers Weekly"/></a></li>
                <li class="title"><div><span id="dsb-pwa_appname"></span><span id="dsb-pwa_title"></span></div></li>
                <li class="tray" id="dsb-pwa_tray">
                  `+this._html_refresh+this._html_offlineindicator+this._html__closebutton+`
                </li>
              </ul>
            </header>
            <dsb-workspace>
              <iframe style="width: 100%;
  height: 100%;margin: 0;
  border: 0;
  scroll-behavior: auto;" src="https://app.comrisk.nl/dairy_hedging"></iframe>
            </dsb-workspace>
          `;
          break;
        case "tabbed":
          this.innerHTML = `
            <dsb-modal>
              <header>
                <ul>
                  <li class="title"></li>
                  <li class="logo"></li>
                  <li class="tray"><div class="icon-close" onclick="document.querySelector('dsb-modal').classList.toggle('show');"><span>Close<span></div></li>
                </ul>
              </header>
              <dsb-modal-workspace></dsb-modal-workspace>
            </dsb-modal>
             `+this._html_header+`
            <dsb-workspace>
              <maa-spinner></maa-spinner>
            </dsb-workspace>
          `;
          this.append(tabbed_element);
          break;
        case "maintenance":
           this.innerHTML = `
            <dsb-modal>
              <header>
                <ul>
                  <li class="title"></li>
                  <li class="logo"></li>
                  <li class="tray"><div class="icon-close" onclick="document.querySelector('dsb-modal').classList.toggle('show');"><span>Close<span></div></li>
                </ul>
              </header>
              <dsb-modal-workspace></dsb-modal-workspace>
            </dsb-modal>
             `+this._html_header+`
            <dsb-workspace>
             <div style="overflow-x: auto;min-height:200px;margin-top:30px;">
                  <article class="error-503" role="article">
                    <p>Maintenance work ongoing...</p>
                    <p>Sorry we are currently performing maintenance please <a href="javascript:return;" onclick="window.location.reload(true);">click here</a> to try again.</p>
                  </article>
              </div>
            </dsb-workspace>
            `;
            return false;
          break;
        case "login":
          this.innerHTML = `
            <dsb-modal>
              <header>
                <ul>
                  <li class="title"></li>
                  <li class="logo"></li>
                  <li class="tray"><div class="icon-close" onclick="document.querySelector('dsb-modal').classList.toggle('show');"><span>Close<span></div></li>
                </ul>
              </header>
              <dsb-modal-workspace></dsb-modal-workspace>
            </dsb-modal>
             `+this._html_header+`
            <dsb-workspace>
             <div style="overflow-x: auto;min-height:200px;margin-top:30px;">
                  <article class="error-500" role="article">
                    <p>Sorry, you appear to be logged out...</p>
                    <p>Please <a href="`+this.dsbClient.user.get_login_url()+`">click here to login</a>.<br/>
                    Once you have <a href="javascript:return;" onclick="window.location.reload(true);">please click here</a> to try again.</p>
                  </article>
              </div>
            </dsb-workspace>
            `;
            return false;
            break;
        case "login-iframe":
            this.innerHTML = `
            <dsb-workspace>
              <div style="overflow-x: auto;height:100%;padding:10px">
                    <article role="article">
                      <div class="m-icon-login" style="color:var(--fwwb-header-colour-bg);font-size:calc(var(--fwwb-fullwidth)/3);width:100%;text-align:center"></div>
                      <p>This feature requires login and you appear to be logged out...</p>
                      <p><button onclick="location.hash='/login-pending';window.open('`+this.dsbClient.user.get_login_url()+`');window.location.reload(true);">Click here to login</button><br>
                      Once you have <a href="javascript:return;" onclick="window.location.reload(true);">please click here</a> to try again.</p>
                    </article>
                </div>
             </dsb-workspace>`;
            break;
        case "login-pending":
            this.innerHTML = `<maa-spinner>Waiting for successfull login...</maa-spinner>`;
            let _login_pending_timeout_count=0;
            let function__login_pending_timeout = function(){
              try
              {
                _login_pending_timeout_count++;
                if(_this.dsbClient.user.hasJWTCookie())
                {
                  location.hash='';
                  window.location.reload(true);
                }
                else if(_login_pending_timeout_count>50)
                {
                  clearInterval(_login_pending_timeout);
                  location.hash='/login-iframe';
                  window.location.reload(true);
                }
              }
              catch(ex)
              {
                _this._log('error','layout:login-pending',ex);
                _this._throwFatalError();
              }
            };
            function__login_pending_timeout();
            let _login_pending_timeout = setInterval(function__login_pending_timeout,5000);
            return false;
            break;
        case "error":
          return this._throwFatalError();
            break;
        case "offline":
            this.innerHTML = `

            <dsb-modal>
              <header>
                <ul>
                  <li class="title"></li>
                  <li class="logo"></li>
                  <li class="tray"><div class="icon-close" onclick="document.querySelector('dsb-modal').classList.toggle('show');"><span>Close<span></div></li>
                </ul>
              </header>
              <dsb-modal-workspace></dsb-modal-workspace>
            </dsb-modal>
             `+this._html_header+`
            <dsb-workspace>
               <div style="overflow-x: auto;min-height:200px;margin-top:30px;">
                  <article class="error-90" role="article">
                    <p>Offline</p>
                    <p>Sorry, offline version not available.<br/>Please try again later when you have an internet connection :)</p>
                    <details>
                      <summary>Details</summary>
                      <div>
                        `+this._errorMessage+`
                      </div>
                    </details>
                  </article>
              </div>
            </dsb-workspace>
            `;
            this._errorMessage='';
            break;
        default:
          return this._throwFatalError('unknown layout='+this.layout);
      }

      this._rendered_layout = this.layout;

      // Set title
      if((typeof this.setting === 'object') && (this.setting !== null) && ('title' in this.setting) && this.setting.title == 'on')
      {
        let base_update_detail = {appname:document.title};
        if('override_title' in this.setting)
        {
          base_update_detail.appname=this.setting.override_title;
        }
        if('flag_beta' in this.setting && this.setting.flag_beta=='on')
        {
          base_update_detail.appname+='<span style="color:red;font-size:9px;vertical-align:super;padding-left:5px;">beta</span>';
        }
        window.dispatchEvent(new CustomEvent('dsb-pwa-base_update', {detail:base_update_detail}));
      }
      window.dispatchEvent(new CustomEvent('fw-workspace-offline_status'));
      return true;
    }
    catch(ex)
    {
      return this._throwFatalError('_render:'+ex);
    }

  }

  _throwFatalError(message=null)
  {
    if(!(typeof message === 'string'))
    {
      message=this._errorMessage;
    }

    this.innerHTML = `
        <dsb-modal>
          <header>
            <ul>
              <li class="title"></li>
              <li class="logo"></li>
              <li class="tray"><div class="icon-close" onclick="document.querySelector('dsb-modal').classList.toggle('show');"><span>Close<span></div></li>
            </ul>
          </header>
          <dsb-modal-workspace></dsb-modal-workspace>
        </dsb-modal>
      `+this._html_header+`
      <dsb-workspace>
        <div class="dsb-workspace-overlay"></div>
        <div style="overflow-x: auto;min-height:200px;margin-top:30px;">
            <article class="error-500" role="article">
              <p>Sorry an error has occured.</p>
              <p>
                Please try again by <a href="javascript:return;" onclick="window.location.reload(true);">clicking here</a> or try again later.
              </p>
              <p>
                <details>
                  <summary>Details</summary>
                  <div>
                    `+message+`
                  </div>
                </details>
              </p>
            </article>
        </div>
      </dsb-workspace>
      `;
       // Clear our tray
      let pwa_tray = document.getElementById('dsb-pwa_tray');
      if(pwa_tray instanceof HTMLElement)
      {
        pwa_tray.innerHTML = '';
        if((typeof this.setting === 'object') && (this.setting !== null))
        {
          if('tray_feedback' in this.setting)
          {
            switch(this.setting['tray_feedback'].toLowerCase())
            {
              case "off":
                  break;
              default:
                  this.add_feedback('dsb-pwa_tray');
                  break;
            }
          }
          else
          {
            this.add_feedback('dsb-pwa_tray');
          }
        }
        else
        {
          this.add_feedback('dsb-pwa_tray');
        }
        this.add_refresh('dsb-pwa_tray');
      }
      console.error('dsb-app: Fatal Error',message,this._errorMessage);
      this._errorMessage='';
      return false;
  }

  async login()
  {
    let url = "https://www.fwi.co.uk/wp-login.php?action=refresh&type=pm-sso-token-redirect";
    let response = await fetch(url);
    console.log(response);
  }

  route(element)
  {
    if(element instanceof HTMLElement)
    {
      let service = element.getAttribute('data-service');
      let query = element.getAttribute('data-query');
      let id = element.getAttribute('data-id');
      let target = element.getAttribute('data-target');
      let type = element.getAttribute('data-type');
      if(id)
      {
        query = id;
      }
      this._route(this.layout, service, type, query, target);
    }
    else
    {
      console.log('router.routeByElement: Not an element');
    }
  }

  add_menu(tray_id,menu_items)
  {
      let _this = this;
      if(true)
      {
        var menu_aside = document.createElement("aside");
        menu_aside.id="menu_aside_"+tray_id;
        menu_aside.setAttribute('class','left');

        window.dispatchEvent(new CustomEvent('dsb-pwa-append_tray', {detail: {onclick: async function(){
          let zindex = window.getZIndex(document.getElementById(tray_id));
          let panel = document.getElementById('menu_aside_'+tray_id);
          if(!('_updated' in panel))
          {
            panel._updated={};
          }
          let _updated=panel._updated;

          if(zindex && !isNaN(zindex))
          {
            panel.style.zIndex = zindex+1;
          }
          panel.innerHTML = `
            <maa-spinner></maa-spinner>
          `;
          panel.classList.toggle('show');
          let menu_open = false;
          if(!(panel.classList.contains('show')))
          {
            panel.innerHTML = ``;
          }
          else
          {
            menu_open=true;
          }

          if(menu_open)
          {
            try
            {
              window.dispatchEvent(new CustomEvent('dsb-pwa-page_event', {detail:{
                'event_type':'interaction',
                'data': {
                  'source':'dsb-app.menu',
                  'action':'open'
                }
              }}));

              let menu_close_click=function(){
                document.getElementById(tray_id+'__menu').click();
              };
              let menu_close = document.createElement('span')
              menu_close.classList.add('m-icon-close');
              menu_close.classList.add('icon-clickable');
              menu_close.style='position:absolute;top:5px;right:5px;z-index:1;';

              menu_close.onclick=function(){
                menu_close_click();
              };

              let menu_ul = document.createElement('ul');
              let menu_div = document.createElement('div');
              menu_div.style.position = 'relative';
              menu_div.append(menu_ul);


              for(let i=0;i<menu_items.length;i++)
              {
                if('name' in menu_items[i] && 'type' in menu_items[i] && 'value' in menu_items[i])
                {
                  let menu_li = document.createElement("li");
                  menu_li.innerHTML=menu_items[i].name;
                  let menu_li_click=function(){};
                  switch(menu_items[i].type)
                  {
                    case "post_id":
                      menu_li_click=function(){
                        let component = document.createElement("dsb-post");
                        component.setDSBClient(_this.dsbClient);
                        component.setAttribute(`service`, 'static');
                        component.setAttribute('post_id', menu_items[i].value);
                        component.setAttribute(`settings`, JSON.stringify({'clean_body':'on','pulldown_refresh':'on','toolbar':'off'}));
                        component.innerHTML = `<maa-spinner></maa-spinner>`;
                        window.dispatchEvent(new CustomEvent('dsb-pwa-page_event', {detail:{
                          'event_type':'interaction',
                          'data': {
                            'source':'dsb-app.menu',
                            'action':'open',
                            'id': menu_items[i].value
                          }
                        }}));
                        window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content:component}}));
                        menu_close_click();
                      }
                      break;
                    case "url":
                      menu_li.classList.add('external-link');
                      menu_li.classList.add('fw_workspace__online_only');
                      menu_li.setAttribute('data-offlineonly_toggleClass','offline');
                      menu_li_click=function(){
                        let location = menu_items[i].value;
                        window.open((location.startsWith('http')?location:'https://'+location),'_blank');
                        menu_close_click();
                      }
                    break;
                    case "innerHTML":
                      menu_li.innerHTML=menu_items[i].value;
                    break;
                    case "HTMLElement":
                      if(menu_items[i].value instanceof HTMLElement)
                      {
                        menu_li.innerHTML='';
                        menu_li.append(menu_items[i].value);
                      }
                      else
                      {
                        menu_li=false;
                      }
                    break;
                    default:
                      break;
                  }

                  if(menu_li)
                  {
                    menu_li.onclick=function(){
                      if(this.classList.contains('flash'))
                      {
                        this.classList.remove('flash');
                      }
                      this.style.setProperty('--fwwb-flash-from','var(--fwwb-body-colour-font)');
                      this.style.setProperty('--fwwb-flash-to','var(--fwwb-body-colour-bg)');
                      this.classList.add('flash');
                      menu_li_click();
                    }

                    menu_ul.append(menu_li);
                  }
                }
                else
                {
                  _this._log('error','add_menu','Missing name, type, value',menu_items[i]);
                }
              }


              // Settings
              let _registered_settings_elements = {};
              let settings_panel = document.createElement('div');
              settings_panel.classList.add("submenu");
              let settings_content = document.createElement('div');
              settings_content.style="overflow-y: auto;height: calc(var(--fwwb-fullheight-modal) - 50px);margin-top:50px;";
              let settings_panel_title = document.createElement('h3');
              settings_panel_title.classList.add('m-icon-left');
              settings_panel_title.innerHTML=`Settings`;
              settings_panel_title.style="position: fixed;width: 100%;";

              let settings_panel_ul = document.createElement('ul');
              if(_this.dsbClient.user.custom_settings)
              {
                let available_settings_keys = _this.dsbClient.user.custom_settings.get_settings(true);

                _this._log('debug','add_menu','available_settings_keys',available_settings_keys);
                if(Array.isArray(available_settings_keys))
                {
                  for(let i=0;i<available_settings_keys.length; i++)
                  {
                    let available_settings = await _this.dsbClient.user.custom_settings.get_setting(available_settings_keys[i]);
                    _this._log('debug','add_menu','available_settings',available_settings);
                    let settings_panel_item = document.createElement("li");
                    settings_panel_item.innerHTML=`
                    <h3>`+available_settings.name+`</h3>`+('desc' in available_settings?`<p>`+available_settings.desc+`</p>`:``)+``;
                    let settings_panel_table = document.createElement("table");
                    settings_panel_table.style="width:100%";
                    if('fields' in available_settings)
                    {
                      let field_data = await _this.dsbClient.user.custom_settings.get(available_settings.key);
                      _this._log('debug','add_menu','custom_settings',{'key':available_settings.key,'data':field_data});
                      _registered_settings_elements[available_settings.key]=[];

                      if('data' in field_data)
                      {
                        field_data=field_data.data;
                      }

                      // Process fields for groups
                      let fields = {};
                      let compount_input ={};
                      compount_input['options']=[];
                      for(let setting_key_field  in available_settings.fields)
                      {
                        if(available_settings.fields[setting_key_field].type == 'select')
                        {
                          compount_input['type']='select';
                          compount_input['options'].push(available_settings.fields[setting_key_field]);
                          if(!('generated::field' in compount_input))
                          {
                            compount_input['generated::field']=document.createElement('select');
                            compount_input['generated::field'].style="width: 100%;";
                          }
                        }
                        else
                        {
                          fields[setting_key_field]=available_settings.fields[setting_key_field];
                          fields[setting_key_field]['generated::field']= document.createElement('input');
                          fields[setting_key_field]['generated::field'].value='';
                          if('settings' in fields[setting_key_field] && 'text_type' in fields[setting_key_field].settings)
                          {
                            fields[setting_key_field].type=fields[setting_key_field].settings.text_type;
                          }
                          fields[setting_key_field]['generated::field'].type=fields[setting_key_field].type;
                          fields[setting_key_field]['generated::field'].style='width:100%;';
                          if(fields[setting_key_field].title in field_data)
                          {
                            fields[setting_key_field]['generated::field'].value = field_data[fields[setting_key_field].title];
                          }
                        }
                      }

                      if('generated::field' in compount_input)
                      {
                        fields['compount_input']=compount_input;
                      }

                      for(let setting_key_field  in fields)
                      {
                        let settings_panel_table_tr = document.createElement("tr");
                        let settings_panel_table_td_label = document.createElement('td');
                        settings_panel_table_td_label.innerHTML='&nbsp;';

                        let settings_panel_table_td_form = document.createElement('td');
                        settings_panel_table_td_form.style="width: 100%;";
                        let field_input = fields[setting_key_field]['generated::field'];
                        _registered_settings_elements[available_settings.key].push(field_input);
                        field_input.name=available_settings.key+'['+fields[setting_key_field].title+']';
                        if('title' in fields[setting_key_field])
                        {
                          settings_panel_table_td_label.innerHTML=fields[setting_key_field].title;
                          field_input.setAttribute('data-item_key',fields[setting_key_field].title);
                        }
                        else
                        {
                          settings_panel_table_td_label=false;
                          settings_panel_table_td_form.colSpan =2;
                        }
                        field_input.setAttribute('data-store_key',available_settings.key);

                        switch(fields[setting_key_field].type)
                        {
                          case "hidden":
                            continue;
                            break;
                          case "select":
                            if('options' in fields[setting_key_field])
                            {
                              for(let i =0; i<fields[setting_key_field]['options'].length;i++)
                              {
                                let option = document.createElement("option");
                                option.innerHTML = fields[setting_key_field]['options'][i].title;
                                option.value = fields[setting_key_field]['options'][i].title;
                                if(option.value in field_data && field_data[option.value] == true)
                                {
                                  option.setAttribute('selected','selected');
                                }
                                field_input.append(option);
                              }
                              field_input.onchange=async function(){
                                try
                                {
                                  let data = {};
                                  data[this.value]=true;
                                  if(!await _this.dsbClient.user.custom_settings.set(available_settings.key, data))
                                  {
                                    throw "Save seems to have failed";
                                  }
                                  _updated[available_settings.key]=true;
                                }
                                catch(ex)
                                {
                                  _this._log('error','menu.save.select',{'error':ex,'object':this});
                                  window.dispatchEvent(new CustomEvent('fw-workspace-trigger_message', {'detail':{'message':'Sorry, failed so save settings','icon':'error','action':'auto_close-2000'}}));
                                }
                              }
                              settings_panel_table_td_form.append(field_input);
                            }
                            else
                            {
                              continue;
                            }
                            break;
                          case "switch":
                            field_input.placeholder=fields[setting_key_field].value;
                            field_input.type='hidden';
                            settings_panel_table_td_form.classList.add('form_switch');
                            settings_panel_table_td_form.append(field_input);
                            let field_input_switch = document.createElement('div');
                            field_input_switch.style="float:right;"
                            if(!('value' in field_input) || !field_input.value || field_input.value=='on')
                            {
                              field_input_switch.classList.add('on');
                              field_input.value='on'
                            }
                            else
                            {
                              field_input.value='off'
                            }

                            field_input_switch.setAttribute('data-item_key',fields[setting_key_field].title);
                            field_input_switch.setAttribute('data-store_key',available_settings.key);

                            field_input_switch.onclick= async function(){
                              try
                              {
                                let store_key = this.getAttribute('data-store_key');
                                let item_key = this.getAttribute('data-item_key');

                                if(this.classList.contains('on'))
                                {
                                  field_input_switch.classList.remove('on');
                                  field_input.value = 'off';
                                }
                                else
                                {
                                  field_input_switch.classList.add('on');
                                  field_input.value = 'on';
                                }

                                //Retreave all for form
                                if(store_key in _registered_settings_elements)
                                {
                                  let data = {};
                                  for(let i=0; i<_registered_settings_elements[store_key].length;i++)
                                  {
                                    if(_registered_settings_elements[store_key][i] instanceof HTMLElement)
                                    {
                                      let _item_key = _registered_settings_elements[store_key][i].getAttribute('data-item_key');
                                      if('value' in _registered_settings_elements[store_key][i])
                                      {
                                        data[_item_key]=_registered_settings_elements[store_key][i].value;
                                      }
                                      else
                                      {
                                        throw "Item.value missing";
                                      }
                                    }
                                    else
                                    {
                                      throw "Item not an instanceof HTMLElement";
                                    }
                                  }
                                  if(!await _this.dsbClient.user.custom_settings.set(available_settings.key, data))
                                  {
                                    throw "Save seems to have failed";
                                  }

                                  _updated[available_settings.key]=true;
                                }
                              }
                              catch(ex)
                              {
                                _this._log('error','menu.save',{'error':ex,'object':this});
                                window.dispatchEvent(new CustomEvent('fw-workspace-trigger_message', {'detail':{'message':'Sorry, failed so save settings','icon':'error','action':'auto_close-2000'}}));
                              }

                            }
                            settings_panel_table_td_form.append(field_input_switch);
                            break;
                          default:
                            field_input.placeholder=fields[setting_key_field].value;
                            settings_panel_table_td_form.append(field_input);
                            break;
                        }

                        if(settings_panel_table_tr instanceof HTMLElement)
                        {
                          if(settings_panel_table_td_label instanceof HTMLElement)
                          {
                            settings_panel_table_tr.append(settings_panel_table_td_label);
                          }
                          settings_panel_table_tr.append(settings_panel_table_td_form);
                          settings_panel_table.append(settings_panel_table_tr);
                        }
                      }
                      settings_panel_item.append(settings_panel_table);
                    }
                    else if('getBody' in available_settings)
                    {
                      if(typeof available_settings.getBody == 'function')
                      {
                        settings_panel_item.append(await available_settings.getBody());
                      }

                    }
                    settings_panel_ul.append(settings_panel_item);
                  }
                }
              }

              settings_panel.append(settings_panel_title);
              settings_content.append(settings_panel_ul);
              settings_panel.append(settings_content);

              let settings_li = document.createElement("li");
              settings_li.innerHTML='Settings';
              settings_li.classList.add('m-icon-right-after');
              settings_li.classList.add('fw_workspace__online_only');
              settings_li.setAttribute('data-offlineonly_toggleClass','offline');
              settings_li.onclick=function(){
                window.dispatchEvent(new CustomEvent('fw-workspace-trigger_event', {'detail':{'event':'touch','source':'menu_settings'}}));
                if(settings_panel.classList.contains('show'))
                {
                  settings_panel.classList.remove('show');
                  // Fire off any events
                  for(let key in _updated)
                  {
                    // do something
                    _this.do_hook('updated_setting-'+key);
                    delete _updated[key];
                  }
                }
                else
                {
                  settings_panel.classList.add('show');
                }
              };
              menu_ul.append(settings_li);

              settings_panel_title.onclick=function(){
                settings_li.click();
              }

              let refresh_li = document.createElement("li");
              refresh_li.innerHTML='Refresh<span>Reload the app and all articles and other content</span>';
              refresh_li.classList.add('icon-refresh-after');
              refresh_li.classList.add('icon-clickable');
              refresh_li.classList.add('fw_workspace__online_only');
              refresh_li.setAttribute('data-offlineonly_toggleClass','offline');
              refresh_li.onclick=function(){
                window.location.reload(true);
                this.className='icon-refresh-after icon-rotate-after icon-clickable'
              }

               menu_ul.append(refresh_li);

              //'font-size:25px;position:absolute;bottom:10px;right:10px;';

              panel.innerHTML = ``;
              panel.append(menu_close);
              panel.append(settings_panel);
              panel.append(menu_div);
              window.dispatchEvent(new CustomEvent('fw-workspace-offline_status'));
            }
            catch(ex)
            {
              console.error(ex);
              panel.innerHTML = `
                <div style="overflow-x: auto;min-height:200px;margin-top:30px;">
                    <article class="error-500" role="article">
                      <p style="font-size: 2em;">Sorry an error has occured.</p>
                      <p>Please try again later.</p>
                      <details>
                        <summary>Details</summary>
                        <div>
                          `+JSON.stringify(ex)+`
                        </div>
                      </details>
                    </article>
                </div>`;
            }
          }
          else
          {
             for(let key in _updated)
              {
                  _this.do_hook('updated_setting-'+key);
                  delete _updated[key];
              }
          }


        },icon: 'icon-menu',
          name: 'menu',
          icon_size: '25px',
          init_append:menu_aside,
          overlay:true,
          tray_id: tray_id
        }}));

      }
  }

  add_applist(tray_id)
  {
      let _this = this;
      // Set Feedback form
      if(`feedback_form_url` in _this.setting)
      {
        var apps_aside = document.createElement("aside");
        apps_aside.id="apps_aside_"+tray_id;
        apps_aside.setAttribute('class','right');
        apps_aside.setAttribute('data-append_location','');
        //feedback_aside.setAttribute('style','padding:10px;');

        window.dispatchEvent(new CustomEvent('dsb-pwa-append_tray', {detail: {onclick: async function(){

          let zindex = window.getZIndex(document.querySelector('#'+tray_id));
          let panel = document.querySelector('#apps_aside_'+tray_id);
          let append_location = panel.getAttribute('data-append_location');

          if(zindex && !isNaN(zindex))
          {
            panel.style.zIndex = zindex+1;
          }
          panel.innerHTML = `
            <maa-spinner></maa-spinner>
          `;
          panel.classList.toggle('show');
          if(!(panel.classList.contains('show')))
          {
            panel.innerHTML = ``;
          }

          try
          {

          }
          catch(ex)
          {
            console.error(ex);
            panel.innerHTML = `
              <div style="overflow-x: auto;min-height:200px;margin-top:30px;">
                  <article class="error-500" role="article">
                    <p style="font-size: 2em;">Sorry an error has occured.</p>
                    <p>Please try again later.</p>
                  </article>
              </div>`;
          }


        },icon: 'm-icon-apps',
          name: 'apps',
          icon_size: '25px',
          init_append:apps_aside,
          overlay:true,
          tray_id: tray_id
        }}));

      }
  }

  /**
  ______add_menu(id)
  {
      let pwa_menu = document.getElementById(id);
      if(pwa_menu instanceof HTMLElement)
      {
        pwa_menu.onclick = function(){
          console.error('#1:clicked');
          let workspace = window.getWorkspace(this);
          workspace.querySelector('.dsb-workspace-overlay').onclick=function(){
            pwa_menu.click();
          };
          this.classList.toggle('active');
          if(workspace !== null || typeof workspace == 'object')
          {
            workspace.querySelector('.dsb-workspace-overlay').classList.toggle('show');
          }
          panel.classList.toggle('show');
          if(!(panel.classList.contains('show')))
          {
            panel.innerHTML = ``;
          }

          try
          {

          }
          catch(ex)
          {
            console.error(ex);
            panel.innerHTML = `
              <div style="overflow-x: auto;min-height:200px;margin-top:30px;">
                  <article class="error-500" role="article">
                    <p style="font-size: 2em;">Sorry an error has occured.</p>
                    <p>Please try again later.</p>
                  </article>
              </div>`;
          }
        };

        let panel = document.createElement("aside");
        panel.id="menu_aside";
        panel.setAttribute('class','left');
        workspace.append(panel);

        let zindex = window.getZIndex(panel);

        if(zindex && !isNaN(zindex))
        {
          panel.style.zIndex = zindex+1;
        }
        panel.innerHTML = `
          <maa-spinner></maa-spinner>
        `;
      }
      else
      {
        this._log('error','add_menu',id+' is not an HTMLElement',id)
      }
  }
  */

  add_refresh(tray_id)
  {
    window.dispatchEvent(new CustomEvent('dsb-pwa-append_tray', {detail: {onclick: async function(){
          window.location.reload(true);
          this.className='icon-refresh icon-rotate icon-clickable';
        },icon: 'icon-refresh',
          online_only:true,
          name: 'refresh',
          icon_size: '25px',
          overlay:false,
          tray_id: tray_id
        }}));
  }

  add_feedback(tray_id,settings={})
  {
      let _this = this;
      // Set Feedback form
      if(`feedback_form_url` in _this.setting)
      {
        var feedback_aside = document.createElement("aside");
        feedback_aside.id="feedback_aside_"+tray_id;
        feedback_aside.setAttribute('class','right');
        if('append_location' in settings)
        {
          feedback_aside.setAttribute('data-append_location',settings.append_location);
        }
        else
        {
          feedback_aside.setAttribute('data-append_location','');
        }
        if('metadata' in settings)
        {
          feedback_aside.setAttribute('data-metadata',settings.metadata);
        }
        else
        {
          feedback_aside.setAttribute('data-metadata','');
        }
        //feedback_aside.setAttribute('style','padding:10px;');

        window.dispatchEvent(new CustomEvent('dsb-pwa-append_tray', {detail: {onclick: async function(){

          let zindex = window.getZIndex(document.querySelector('#'+tray_id));
          let panel = document.querySelector('#feedback_aside_'+tray_id);

          let metadata = false;
          if(panel.hasAttribute('data-metadata'))
          {
            metadata=panel.getAttribute('data-metadata');
          }
          let append_location = false;
          if(panel.hasAttribute('data-append_location'))
          {
            append_location='/-/'+panel.getAttribute('data-append_location');
          }

          if(zindex && !isNaN(zindex))
          {
            panel.style.zIndex = zindex+1;
          }
          panel.innerHTML = `
            <maa-spinner></maa-spinner>
          `;

          if(!(panel.classList.contains('show')))
          {
            window.dispatchEvent(new CustomEvent('dsb-pwa-page_event', {detail:{
                'event_type':'interaction',
                'data': {
                  'source':'dsb-app.feedback',
                  'action':'open'
                }
              }}));
          }

          panel.classList.toggle('show');
          if(!(panel.classList.contains('show')))
          {
            panel.innerHTML = ``;
          }

          try
          {
            if('email' in _this.dsbClient.user.profile)
            {
              var feedback_aside_wrapper = document.createElement("div");
              feedback_aside_wrapper.setAttribute("style","border:0px;margin:0px;padding-left:10px;padding-right:10px;height:calc(100vh - 3em);");
              var feedback_aside_iframe = document.createElement("iframe");
              feedback_aside_iframe.id = 'feedback_aside_'+tray_id+'_iframe';
              feedback_aside_iframe.src = _this.setting.feedback_form_url+"&email="+_this.dsbClient.user.profile.email+"&sourceurl="+location+(append_location?append_location:'')+(metadata?'&metadata='+metadata:'');
              feedback_aside_iframe.setAttribute("data-target_url",_this.setting.feedback_form_url+"&email="+_this.dsbClient.user.profile.email+"&sourceurl="+location+(append_location?append_location:'')+(metadata?'&metadata='+metadata:''));
              feedback_aside_iframe.setAttribute("width","100%");
              feedback_aside_iframe.setAttribute("height","100%");
              feedback_aside_iframe.setAttribute("style","border:0px;margin:0px;padding:0px;");
              panel.innerHTML = ``;
              feedback_aside_wrapper.append(feedback_aside_iframe);
              panel.append(feedback_aside_wrapper);
            }
          }
          catch(ex)
          {
            console.error(ex);
            panel.innerHTML = `
              <div style="overflow-x: auto;min-height:200px;margin-top:30px;">
                  <article class="error-500" role="article">
                    <p style="font-size: 2em;">Sorry an error has occured.</p>
                    <p>Please try again later.</p>
                  </article>
              </div>`;
          }


        },icon: 'm-icon-feedback',
          online_only:true,
          name: 'feedback',
          icon_size: '25px',
          init_append:feedback_aside,
          overlay:true,
          tray_id: tray_id
        }}));

      }
  }

  async _route(app, service, type, query, target)
  {
      let _this = this;
      let rendered = false;

      try
      {
        if(app)
        {
          this._log('debug','_route','Ok routing for app ('+app+')..');
          if(this._rendered_layout !== app)
          {
            this.setAttribute(`layout`, app);
            rendered = await this._render();
          }
          else
          {
            rendered=true;
          }
        }
        else
        {
          throw 'Dunno what to do';
        }

        if(rendered)
        {

          this._log('debug','_route','Ok, has rendered');
          if(!service)
          {

            this._log('error','_route','Routing error...',{'service':service,'rendered':rendered});
            return;
          }


          if('dsb-modal-workspace' == target)
          {
            target = document.body.querySelector(target);
            target.innerHTML = `<maa-spinner></maa-spinner>`;
            document.querySelector('dsb-modal').classList.toggle('show');
          }
          else if(target)
          {
              target = document.body.querySelector(target);
          }
          else
          {
              target = document.body.querySelector('dsb-workspace');
          }

          var overlay = document.createElement("div");
          overlay.setAttribute(`class`,"dsb-workspace-overlay");
          overlay.innerHTML = '';

          // Set tabs
          let tabs = this.querySelectorAll('nav li a');

          if(tabs.length > 0)
          {
              for(let i=0;i<tabs.length;i++)
              {
                if(tabs[i].classList.contains('active'))
                {
                  tabs[i].classList.remove('active');
                }
                if(tabs[i].id == `/`+app+`/`+service+`/`+type+`/`+query)
                {
                  tabs[i].classList.add('active');
                }
              }
          }


          switch(type)
          {
            case "collection":
                this._dynamic_define_component('dsb-reader');
                this._dynamic_define_component('dsb-tasks');
                this._dynamic_define_component('dsb-quiz');
                this._dynamic_define_component('dsb-post');
                var component = document.createElement("dsb-reader");
                component.setDSBClient(this.dsbClient);
                component.setAttribute(`service`, service);
                component.collection_id = query;
                component.innerHTML = `<maa-spinner></maa-spinner>`;
                target.innerHTML = ``;
                target.append(overlay);
                target.append(component);
                break;
            case "board":
                var component = document.createElement("dsb-board");
                component.setDSBClient(this.dsbClient);
                component.setAttribute(`service`, service);
                component.collection_id = query;
                component.innerHTML = `<maa-spinner></maa-spinner>`;
                target.innerHTML = ``;
                target.append(overlay);
                target.append(component);
                break;
            case "post":
                this._dynamic_define_component('dsb-post');
                this._dynamic_define_component('dsb-list');
                this._dynamic_define_component('dsb-stepbar');
                this._dynamic_define_component('dsb-reader');
                this._dynamic_define_component('dsb-tasks');
                this._dynamic_define_component('dsb-quiz');
                this._dynamic_define_component('dsb-audio');
                this._dynamic_define_component('dsb-video');
                var component = document.createElement("dsb-post");
                component.setDSBClient(this.dsbClient);
                component.setAttribute(`service`, service);
                component.setAttribute('post_id', query);
                component.innerHTML = `<maa-spinner></maa-spinner>`;
                target.innerHTML = ``;
                target.append(overlay);
                target.append(component);
                break;
            default:
                this._dynamic_define_component('dsb-post');
                this._dynamic_define_component('dsb-list');
                var component = document.createElement("dsb-list");
                component.setDSBClient(this.dsbClient);
                component.setAttribute(`service`, service);
                component.setAttribute(`query`, query);
                component.setAttribute(`type`, type);
                component.setAttribute(`root_path`, this.layout);
                component.innerHTML = `<maa-spinner></maa-spinner>`;
                target.innerHTML = ``;
                target.append(component);
                break;
          }


          //Add menu
          let pwa_menu =  document.getElementById('dsb-pwa_menu');
          if(pwa_menu instanceof HTMLElement)
          {
            let menu_items = [];
            if(this.menus)
            {
              for(let menu_key in this.menus)
              {
                menu_items.push({'name':this.menus[menu_key].name,'type':this.menus[menu_key].type,'value':this.menus[menu_key].value});
              }
            }

            pwa_menu.innerHTML = '';
            this.add_menu('dsb-pwa_menu',menu_items);
          }


          // Clear our tray
          let pwa_tray = document.getElementById('dsb-pwa_tray');
          if(pwa_tray instanceof HTMLElement)
          {
            pwa_tray.innerHTML = '';
            if((typeof this.setting === 'object') && (this.setting !== null))
            {
              if('tray_feedback' in this.setting)
              {
                switch(this.setting['tray_feedback'].toLowerCase())
                {
                  case "off":
                      break;
                  default:
                      this.add_feedback('dsb-pwa_tray');
                      break;
                }
              }
              else
              {
                this.add_feedback('dsb-pwa_tray');
              }

              if('tray_applist' in this.setting)
              {
                switch(this.setting['tray_applist'].toLowerCase())
                {
                  case "off":
                      break;
                  default:
                      this.add_applist('dsb-pwa_tray');
                      break;
                }
              }

            }
            else
            {
              this.add_feedback('dsb-pwa_tray');
            }
          }

          if(!await this.dsbClient.user.is_offline())
          {
            if(!this._onboarding_component_shown && this._onboarding_component && this._onboarding_component instanceof HTMLElement)
            {
              window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content: this._onboarding_component,hide:['refresh','feedback']}}));
              this._onboarding_component_shown=true;
            }


            if(!this._changelog_component_shown && this._changelog_component && this._changelog_component instanceof HTMLElement)
            {
              window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content: this._changelog_component,hide:['refresh','feedback']}}));
              this._changelog_component_shown=true;
            }

            if(!this._inject_component_shown && this._inject_component && this._inject_component instanceof HTMLElement)
            {
              this.append(this._inject_component);
              this._inject_component_shown=true;
            }

          }
          else
          {
            window.dispatchEvent(new CustomEvent('fw-workspace-offline_status'));
          }
          this._log('debug','_route','Fetched '+service+'('+query+'), '+target);
        }
      }
      catch(ex)
      {
        this._log('error','_route','Fatal error',ex);
        return this._throwFatalError('_route:'+ex);
      }
  }
}


customElements.define('dsb-app', DSBAPP);
